function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.18669 0.855644C1.4166 0.855644 1.64771 0.93718 1.82345 1.10025L6.02076 4.97602C6.19048 5.1335 6.28558 5.34684 6.28558 5.57022C6.28558 5.79249 6.19048 6.00583 6.02076 6.16332L1.82345 10.0413C1.47077 10.3675 0.900213 10.3675 0.547528 10.0391C0.196047 9.7107 0.197251 9.18016 0.549935 8.85401L4.10447 5.57023L0.549935 2.28644C0.19725 1.96029 0.196047 1.43087 0.547528 1.10249C0.723268 0.937181 0.955583 0.855644 1.18669 0.855644Z",
  fill: "#808080"
});

function SvgChevron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.2550458b.svg";
export { ForwardRef as ReactComponent };